import { render, staticRenderFns } from "./WikiAdmin.vue?vue&type=template&id=8c4b7a9a"
import script from "./WikiAdmin.vue?vue&type=script&lang=js"
export * from "./WikiAdmin.vue?vue&type=script&lang=js"
import style0 from "./WikiAdmin.vue?vue&type=style&index=0&id=8c4b7a9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports